import { SxProps, Theme } from '@mui/material';

// The input rule needs three classes to outrank the theme's own padding,
// which loads later.
export const designSearchFieldSx = {
  '& .MuiInputBase-root': {
    height: '52px',
    pl: '16px',
    borderRadius: 0
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: 0
  },
  '& .MuiInputAdornment-root': {
    ml: 0,
    mr: '8px'
  },
  '& .MuiInputBase-root svg': {
    fontSize: '20px'
  },
  '& .MuiOutlinedInput-root .MuiOutlinedInput-input.MuiInputBase-input': {
    py: '16px',
    pl: 0,
    pr: '16px',
    fontSize: '14px',
    lineHeight: '20px',
    height: '20px'
  }
} satisfies SxProps<Theme>;
